<template>
  <div>
    <div class="title-wrap">
      <div class="img">
        <img src="../assets/images/left.png" alt @click="$router.back(-1)"/>
      </div>
      <span>{{text}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Title",
  data() {
      return {
          
      }
  },
  props:{
      text:String
  }
};
</script>

<style lang="less" scoped>
.title-wrap {
  background: #fff;
  text-align: center;
  color: #333;
  font-size: 34px;
  width: 100%;
  height: 90px;
  line-height: 90px;
  box-sizing: border-box;
  position: sticky;
  border-bottom: 1px solid #f2f2f2;
  top: 0;
  z-index: 99;
  .img {
    height: 43px;
    width: 43px;
    float: left;
    margin: 10px 0 0 30px;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
</style>